import { render } from "./ItemMesin.vue?vue&type=template&id=ffa74650&scoped=true"
import script from "./ItemMesin.vue?vue&type=script&lang=js"
export * from "./ItemMesin.vue?vue&type=script&lang=js"

import "./ItemMesin.vue?vue&type=style&index=0&id=ffa74650&scoped=true&lang=css"
import "./ItemMesin.vue?vue&type=style&index=1&id=ffa74650&lang=scss"

import exportComponent from "/Users/anwarfuadi/Documents/nyp/gigihpack.com/fe/gigihpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffa74650"]])

export default __exports__